import React, { Component } from 'react';
import { Link } from 'react-router-dom'

// import Custom Componenets
import Breadcrumb from '../common/breadcrumb.component';
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import classnames from 'classnames';
import { DataToken } from '../../function/Format';
import Switch from "react-switch";

// koneksi
import { PostMain, GetMain, DeleteMain, Post, Get } from '../../function/Koneksi';

const formInput = {
	uuid: '',
	uuid_list_api: '',
	tgl_pembelian: '',
	durasi_expired: '',
	tgl_expired: '',
	lisensi: '',
	no_invoice: '',
	total_biaya:'',
  };

class InvoicePembelian extends Component {

	constructor(props) {
		super(props);
		this.state = {
			data: [],
			pagination: [],
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
				edit: false,
			},
			awal: "",
			sebelum: "",
			hal: [],
			setelah: "",
			akhir: "",
			dt: formInput,
			judul: "Tambah Invoice Pembelian",
			alert: null,
			show: false,
			basicTitle: '',
			basicType: "default",
			pesanAlert: '',

			dataCari: {
				q: '',
			},
			loadingPreview: false,
			masaAktif: '',
			lisensi: null,
			frmStatus: [],
			link_gambar: '',
      		fileSuratDesa: '',	
			akun: DataToken(localStorage.getItem('access_token')),
			//Tab Pane
			active_tab_icon: '1',
			// Tab Vertical
            active_tab_vertical: '1',
			data_lisensi: [],
			data_layanan: null,
			data_detail_layanan: {
				pelayanan: '',
				icon: '',
				image: '',
				route: '',
				title: '',
			},
			config_list_layanan_desa: {
				status_absensi: false,
				status_todolist: false
			},
			list_layanan_desa_mobile: [],
			list_layanan_capil_mobile: [],
			list_layanan_kua_mobile: [],
			list_layanan_desa_web: [],
			list_layanan_capil_web: [],
			list_layanan_kua_web: [],
			list_layanan_ppob: [],
			koneksi_web: [],
			// version_desa_app: "",
			// version_min_desa_app: "",
			ketersedian_ttd: '',
			status_tte: '',
			ketersediaan_info: '',
			ketersediaan_pengumuman: '',
			ketersediaan_info_bupati: '',
			riwayat_disposisi: '',
			layanan_capil: '',
			layanan_kua: '',
			layanan_ppob: '',
			pembayaran: '',
			konfig_umum: "none",
			konfig_web: "none",

			checked: false
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleChangeUmum = this.handleChangeUmum.bind(this);
	}

	// Bootstrap tabs function
	toggle_icon(tab) {
		if (this.state.active_tab_icon !== tab) {
			this.setState({
				active_tab_icon: tab
			});
		}
	}

	handleChange(checked, jenis_surat) {
		let stat_check = null
		switch (jenis_surat) {
			// LAYANAN DESA MOBILE
			case "tidak_mampu":
				if(this.state.list_layanan_desa_mobile.tidak_mampu === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						tidak_mampu: stat_check
					}
				})
			  break;
			case "domisili":
				if(this.state.list_layanan_desa_mobile.domisili === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						domisili: stat_check
					}
				})
			  break;
			case "kelahiran":
				if(this.state.list_layanan_desa_mobile.kelahiran === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						kelahiran: stat_check
					}
				})
			  break;
			case "belum_memiliki_rumah":
				if(this.state.list_layanan_desa_mobile.belum_memiliki_rumah === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						belum_memiliki_rumah: stat_check
					}
				})
			  break;
			case "jalan":
				if(this.state.list_layanan_desa_mobile.jalan === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						jalan: stat_check
					}
				})
			  break;
			case "kematian":
				if(this.state.list_layanan_desa_mobile.kematian === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						kematian: stat_check
					}
				})
			  break;
			case "kepemilikan_rumah":
				if(this.state.list_layanan_desa_mobile.kepemilikan_rumah === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						kepemilikan_rumah: stat_check
					}
				})
			break;
			case "penghasilan":
				if(this.state.list_layanan_desa_mobile.penghasilan === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						penghasilan: stat_check
					}
				})
			break;
			case "skck":
				if(this.state.list_layanan_desa_mobile.skck === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						skck: stat_check
					}
				})
			break;
			case "kehilangan":
				if(this.state.list_layanan_desa_mobile.kehilangan === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						kehilangan: stat_check
					}
				})
			break;
			case "usaha":
				if(this.state.list_layanan_desa_mobile.usaha === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						usaha: stat_check
					}
				})
			break;
			case "skgr":
				if(this.state.list_layanan_desa_mobile.skgr === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						skgr: stat_check
					}
				})
			break;
			case "belum_menikah":
				if(this.state.list_layanan_desa_mobile.belum_menikah === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						belum_menikah: stat_check
					}
				})
			break;
			case "tidak_menikah":
				if(this.state.list_layanan_desa_mobile.tidak_menikah === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						tidak_menikah: stat_check
					}
				})
			break;
			case "pindah_menikah":
				if(this.state.list_layanan_desa_mobile.pindah_menikah === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						pindah_menikah: stat_check
					}
				})
			break;
			case "pernah_menikah":
				if(this.state.list_layanan_desa_mobile.pernah_menikah === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_desa_mobile:{
						...this.state.list_layanan_desa_mobile,
						pernah_menikah: stat_check
					}
				})
			break;
			// CAPIL MOBILE
			case "kelahiran_capil_mobile":
				if(this.state.list_layanan_capil_mobile.kelahiran === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_mobile:{
						...this.state.list_layanan_capil_mobile,
						kelahiran: stat_check
					}
				})
			break;
			case "pindah_datang_capil_mobile":
				if(this.state.list_layanan_capil_mobile.pindah_datang === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_mobile:{
						...this.state.list_layanan_capil_mobile,
						pindah_datang: stat_check
					}
				})
			break;
			case "akta_kematian_capil_mobile":
				if(this.state.list_layanan_capil_mobile.akta_kematian === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_mobile:{
						...this.state.list_layanan_capil_mobile,
						akta_kematian: stat_check
					}
				})
			break;
			case "penambahan_anak_capil_mobile":
				if(this.state.list_layanan_capil_mobile.penambahan_anak === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_mobile:{
						...this.state.list_layanan_capil_mobile,
						penambahan_anak: stat_check
					}
				})
			break;
			case "pecah_kk_capil_mobile":
				if(this.state.list_layanan_capil_mobile.pecah_kk === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_mobile:{
						...this.state.list_layanan_capil_mobile,
						pecah_kk: stat_check
					}
				})
			break;
			case "perubahan_data_capil_mobile":
				if(this.state.list_layanan_capil_mobile.perubahan_data === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_mobile:{
						...this.state.list_layanan_capil_mobile,
						perubahan_data: stat_check
					}
				})
			break;
			// KUA MOBILE
			case "pernikahan":
				if(this.state.list_layanan_kua_mobile.pernikahan === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_kua_mobile:{
						...this.state.list_layanan_kua_mobile,
						pernikahan: stat_check
					}
				})
			break;
			// PPOB MOBILE
			case "top_up_bumdes":
				if(this.state.list_layanan_ppob.top_up_bumdes === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_ppob:{
						...this.state.list_layanan_ppob,
						top_up_bumdes: stat_check
					}
				})
			break;
			case "transfer_bank":
				if(this.state.list_layanan_ppob.transfer_bank === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_ppob:{
						...this.state.list_layanan_ppob,
						transfer_bank: stat_check
					}
				})
			break;
			case "va":
				if(this.state.list_layanan_ppob.va === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_ppob:{
						...this.state.list_layanan_ppob,
						va: stat_check
					}
				})
			break;

			// CAPIL Web
			case "kelahiran_capil_web":
				if(this.state.list_layanan_capil_web.kelahiran === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_web:{
						...this.state.list_layanan_capil_web,
						kelahiran: stat_check
					}
				})
			break;
			case "pindah_datang_capil_web":
				if(this.state.list_layanan_capil_web.pindah_datang === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_web:{
						...this.state.list_layanan_capil_web,
						pindah_datang: stat_check
					}
				})
			break;
			case "akta_kematian_capil_web":
				if(this.state.list_layanan_capil_web.akta_kematian === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_web:{
						...this.state.list_layanan_capil_web,
						akta_kematian: stat_check
					}
				})
			break;
			case "penambahan_anak_capil_web":
				if(this.state.list_layanan_capil_web.penambahan_anak === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_web:{
						...this.state.list_layanan_capil_web,
						penambahan_anak: stat_check
					}
				})
			break;
			case "pecah_kk_capil_web":
				if(this.state.list_layanan_capil_web.pecah_kk === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_web:{
						...this.state.list_layanan_capil_web,
						pecah_kk: stat_check
					}
				})
			break;
			case "perubahan_data_capil_web":
				if(this.state.list_layanan_capil_web.perubahan_data === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_capil_web:{
						...this.state.list_layanan_capil_web,
						perubahan_data: stat_check
					}
				})
			break;
			// KUA WEB
			case "pernikahan_kua_web":
				if(this.state.list_layanan_kua_web.pernikahan === true){
					stat_check = checked
				}
				else{
					stat_check = checked
				}
				this.setState({
					list_layanan_kua_web:{
						...this.state.list_layanan_kua_web,
						pernikahan: stat_check
					}
				})
			break;
			default:
				// Tetap menggunakan nilai awal jika tidak ada case yang cocok
				this.setState({
					show: true,
					basicType: "danger",
					basicTitle: "Gagal Ubah Status",
					pesanAlert: `Unrecognized value: ${jenis_surat}`
				})
				console.warn(`Unrecognized value: ${jenis_surat}`);
				break;
		  }

		this.forceUpdate();
		this.setState({ checked, loadingPreview: true, });
		setTimeout(
			function() {
				this.simpanLayanan(checked);
			}.bind(this),
			500
		);
	  }

	handleChangeWeb(checked, jenis_surat) {
		
		// console.log("CHANGE JENIS SURAT")
		// console.log(jenis_surat)
		// console.log(this.state.list_layanan_desa_web[jenis_surat])
		let stat_check = null
		if(this.state.list_layanan_desa_web[jenis_surat] === true){
			stat_check = checked
		}
		else{
			stat_check = checked
		}

		this.setState({
			list_layanan_desa_web:{
				...this.state.list_layanan_desa_web,
				[jenis_surat]: stat_check
			}
		})

		this.forceUpdate();
		this.setState({ checked });
		this.simpanLayanan(checked);
	}

	handleChangeConfigLayananDesa(checked, jenis_konfig){
		let val = 0
		if (checked) {
			val = 1
		}

		this.setState({
			config_list_layanan_desa: {
				...this.state.config_list_layanan_desa,
				[jenis_konfig] : val
			}
		})
	}
		
	handleChangeUmum(checked, jenis_konfig) {
		let status_check = null
		switch (jenis_konfig) {
			// LAYANAN TTD
			case "ketersediaan_ttd":
				if(this.state.ketersedian_ttd === true){
					status_check = checked
				}
				else{
					status_check = checked
				}
				this.setState({
					ketersedian_ttd: status_check,
				})
			  break;
			case "status_tte":
				if(this.state.status_tte === true){
					status_check = checked
				}
				else{
					status_check = checked
				}
				this.setState({
					status_tte: status_check,
				})
			  break;
			case "ketersediaan_info":
				if(this.state.ketersediaan_info === true){
					status_check = checked
				}
				else{
					status_check = checked
				}
				this.setState({
					ketersediaan_info: status_check,
				})
			  break;
			case "ketersediaan_pengumuman":
				if(this.state.ketersediaan_pengumuman === true){
					status_check = checked
				}
				else{
					status_check = checked
				}
				this.setState({
					ketersediaan_pengumuman: status_check,
				})
			  break;
			case "ketersediaan_info_bupati":
				if(this.state.ketersediaan_info_bupati === true){
					status_check = checked
				}
				else{
					status_check = checked
				}
				this.setState({
					ketersediaan_info_bupati: status_check,
				})
			  break;
			case "riwayat_disposisi":
				if(this.state.riwayat_disposisi === true){
					status_check = checked
				}
				else{
					status_check = checked
				}
				this.setState({
					riwayat_disposisi: status_check,
				})
			  break;
			case "layanan_capil":
				if(this.state.layanan_capil === true){
					status_check = checked
				}
				else{
					status_check = checked
				}
				this.setState({
					layanan_capil: status_check,
				})
			  break;
			case "layanan_kua":
				if(this.state.layanan_kua === true){
					status_check = checked
				}
				else{
					status_check = checked
				}
				this.setState({
					layanan_kua: status_check,
				})
			  break;
			case "layanan_ppob":
				if(this.state.layanan_ppob === true){
					status_check = checked
				}
				else{
					status_check = checked
				}
				this.setState({
					layanan_ppob: status_check,
				})
			  break;
			case "pembayarana":
				if(this.state.pembayaran === true){
					status_check = checked
				}
				else{
					status_check = checked
				}
				this.setState({
					pembayaran: status_check,
				})
			  break;
			default:
				// Tetap menggunakan nilai awal jika tidak ada case yang cocok
				this.setState({
					show: true,
					basicType: "danger",
					basicTitle: "Gagal Ubah Status",
					pesanAlert: `Unrecognized value: ${jenis_konfig}`
				})
				console.warn(`Unrecognized value: ${jenis_konfig}`);
				break;
		  }

		this.forceUpdate();
		this.setState({ checked });
	}

	// Toggle Vertical Tab
	toggle_vertical(tab) {
        if (this.state.active_tab_vertical !== tab) {
            this.setState({
                active_tab_vertical: tab
            });
        }
    }

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	}

	onRecieveInput = (value) => {
		this.setState({
			alert: (
				<SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
					You wrote: {value}
				</SweetAlert>
			)
		});
	}

	hideAlert = () => {
		this.setState({
			alert: null
		});
	}

	// ================== Ambil data dari db untuk table ==================
	fetch = (params = {}) => {
		this.setState({
			loadingPreview: true,
		})
		// let link = "";
		
		// if (params.page) {
		// 	switch (params.page) {
		// 		case ">>":
		// 		  link =
		// 			"?page=" +
		// 			Math.ceil(
		// 			  this.state.pagination.total / this.state.pagination.per_page
		// 			);
		// 		  break;
		// 		case ">":
		// 		  link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
		// 		  break;
		// 		case "<":
		// 		  link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
		// 		  break;
		// 		case "<<":
		// 		  link = "?page=1";
		// 		  break;
		// 		default:
		// 		  link = "?page=" + params.page;
		// 		  break;
		// 	  }
		// }

		let id = this.props.location.state.id_desa;

		GetMain('main/web/invoice-pembelian/list-bydesa/' + id, null, (lihat) => {			
			if (lihat.result) {
				this.setState({ 
					data_lisensi: lihat.result.data, 
					pagination: lihat.result,
					loadingPreview: false
				});
				this.pagination(lihat.result);
			}
			else{
				this.setState({ loadingPreview: false, });
			}
		});

	}

	// Pagination
	pagination = (data, tab) => {
		// const data = this.state.pagination;
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
		  let start = 1;
		  let end = 5;
		  let n = 0;
		  let p = 0;
		  if (data.current_page <= 3) {
			start = 1;
			end = 5;
			if (data.last_page > data.current_page) {
			  n = data.current_page + 1;
			}
		  } else {
			p = data.current_page - 1;
			n = data.current_page + 1;
			start = data.current_page - 2;
			end = data.current_page + 2;
		  }
		  if (end >= data.last_page - 2) {
			p = data.current_page - 1;
			if (start >= 5) {
			  start = data.last_page - 4;
			}
			end = data.last_page;
		  }
	
		  for (let i = start; i <= end; i++) {
			let warna = "success";
			if (i === data.current_page) {
			  warna = "danger";
			}
			hal.push(
			  <a
				href={() => false}
				key={i}
				onClick={() => this.fetch({ page: i, tab: tab })}
				className={
				  "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				}
			  >
				{i}
			  </a>
			);
		  }
		  if (p > 0) {
			sebelum = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: p, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{"<"}
			  </a>
			);
		  }
		  if (n > 0) {
			setelah = (
			  <a
				href={() => false}
				onClick={() => this.fetch({ page: n, tab: tab })}
				className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			  >
				{">"}
			  </a>
			);
		  }
	
		  awal = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: 1, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {"<<"}
			</a>
		  );
		  akhir = (
			<a
			  href={() => false}
			  onClick={() => this.fetch({ page: data.last_page, tab: tab })}
			  className="btn btn-success btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
			>
			  {">>"}
			</a>
		  );
		}
	
		
		this.setState({ awal, sebelum, hal, setelah, akhir });
		
	};

	// Cari Data Table
	cariData = e => {
		if (e.key === 'Enter') {
			this.setState({ 
				dataCari:{
					q: e.target.value,
				}, 
			});

			setTimeout(
				function() {
					this.fetch();
				}.bind(this),
				500
			);
		}
	}

	formatCurrency = (value) => {
		return `Rp. ${Number(value).toLocaleString('id-ID')}`;
	};

	currencyFormatter = (cell) => {
		return new Intl.NumberFormat('id-ID', {
		  style: 'currency',
		  currency: 'IDR',
		}).format(cell);
	};

	// Making dynamic function
	handleInputChange = (e, fld) => {
		const value = e.target.value.replace(/\D/g, '');
		this.setState({
			dt:{
				...this.state.dt,
				[fld]: value,
			}
		});
	};

	handleSelectChange = (e, data) => {
		if (e) {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: { value: e.value, label: e.label }
				}
			});
		} else {
			this.setState({ 
				dt:{
					...this.state.dt,
					[data]: "",
				}
			});
		}
	}
	// Making dynamic function
	
	// ================== simpan data ==================

	simpan_akun = e => {
		e.preventDefault();
		this.setState({
			status:{
				...this.state.status,
				btnForm: true,
			}
		})
		this.forceUpdate();
		let cek_pass = document.getElementById("password").value

		let addPengguna = {
			uuid: document.getElementById("uuid").value,
			username: document.getElementById("username").value,
			no_hp: document.getElementById("no_hp").value,
			email: document.getElementById("email").value,
			role: document.getElementById("role").value,
			id_desa: document.getElementById("id_desa").value,
		};

		let psn = '';
		let resstat = 204;
		let metode = "create";
		if (addPengguna.uuid === '') {
			psn = "Tambah";
			resstat = 201;
			addPengguna.uuid = null;
			addPengguna.password = document.getElementById("password").value
		}
		else {
			psn = "Ubah";
			resstat = 200;
			metode = "update";

			if (cek_pass !== '') {
				addPengguna.password = document.getElementById("password").value
			}
		}


		if (addPengguna.password === '' && addPengguna.uuid === '') {
			this.setState({ show: true, basicType: 'danger', basicTitle: 'Daftar Akun Bumdes', pesanAlert: 'Gagal Ubah Data, Password Wajib Diisi !' });
		}
		else {
			Post('bumdes/' + metode, addPengguna.uuid, addPengguna, (res) => {
				this.setState({
					status:{
						...this.state.status,
						btnForm: false,
						form: false,
					}
				})
				this.forceUpdate();
				if (res.status === resstat) {
					this.setState({ show: true, basicType: 'success', basicTitle: 'Daftar Akun Bumdes', pesanAlert: 'Berhasil ' + psn + ' Data' });
				}
				else {
					this.setState({ show: true, basicType: 'danger', basicTitle: 'Daftar Akun Bumdes', pesanAlert: 'Gagal ' + psn + ' Data' });
				}
				this.componentDidMount();
			});
		}
	}

	simpan = e => {
		e.preventDefault();
		this.setState({
			...this.state.status,
			btnForm: true,
			loadingPreview: true,
		});
		this.forceUpdate();
			
		let add = {
			uuid: this.state.dt.uuid,
			uuid_list_api: this.props.location.state.uuid,
			tgl_pembelian: document.getElementById("tgl_pembelian").value,
			tgl_expired: document.getElementById("tgl_expired").value,
			total_biaya : this.state.dt.total_biaya,
		};
	
		let psn = "";
		let resstat = 204;
		let metode = "create";
		if (add.uuid === "") {
		psn = "Tambah";
		resstat = 200;
		add.uuid = null;
		} else {
		psn = "Ubah";
		resstat = 200;
		metode = "update";
		}
		
		PostMain("main/web/invoice-pembelian/" + metode, add.uuid, add, res => {
	
			this.tutupForm();
			this.forceUpdate();
			
			if (res.status === resstat) {
				this.setState({
					loadingPreview: false,
					show: true,
					basicType: "success",
					basicTitle: "Data Invoice Pembelian",
					pesanAlert: "Berhasil " + psn + " Data",
					dt: formInput,
						status: {
						...this.state.status,
						form: false
					}
				});
			} else {
				this.setState({
					loadingPreview: false,
					show: true,
					basicType: "danger",
					basicTitle: "Data Invoice Pembelian",
					pesanAlert: "Gagal " + psn + " Data"
				});
			}
			this.componentDidMount();
		});
	};

	ubahData = data => {
		this.setState({
			...this.state.status,
			btnAksi: true,
			judul: "Ubah Data Request Desa ",
			loadingPreview: true,
		});
		this.forceUpdate();

		if (data) {
			this.setState({
				dt: {
					uuid: data.uuid,
					uuid_list_api: data.uuid_list_api,
					tgl_pembelian: data.tgl_pembelian,
					tgl_expired: data.tgl_expired,
					total_biaya : data.total_biaya,
				},
				status: {
					...this.state.status,
					form: true,
					edit: true,
				},
				loadingPreview: false,
			})
		}
		else{
			this.setState({
				loadingPreview: false,
			})
		}
	};

	konfirmHapus = (id) => {
		this.setState({
			alert: (
				<SweetAlert
					showCancel
					confirmBtnText="Hapus"
					confirmBtnBsStyle="danger"
					cancelBtnBsStyle="success"
					type="danger"
					title="Yakin ingin hapus data ?"
					onCancel={this.hideAlert}
					onConfirm={() => this.hapusData(id)}
				>
					Proses ini tidak dapat dibatalkan!
				</SweetAlert>
			)
		});
	}

	hapusData = (id) => {
		this.hideAlert();
		let psn = "Hapus";
		this.setState({
			loadingPreview: true
		})
		DeleteMain('main/web/invoice-pembelian/delete', id, (res) => {
			if (res === 200) {
				this.setState({ 
					loadingPreview: false,
					show: true, 
					basicType: 'success', 
					basicTitle: 'Data Invoice Pembelian', 
					pesanAlert: 'Berhasil ' + psn + ' Data' 
				});
			}
			else {
				this.setState({ 
					loadingPreview: false, 
					show: true, 
					basicType: 'danger', 
					basicTitle: 'Data Invoice Pembelian', 
					pesanAlert: 'Gagal ' + psn + ' Data' 
				});
			}
			this.componentDidMount();
		})
	}

	bukaForm = (e) => {
		if (e === 'tambah') {
			this.setState({
				id_desa: '',
				dt:formInput,
			})
		}
		this.setState ({
			status: {
				form: true,
			}
		});
		this.forceUpdate();
	}

	tutupForm = () => {
		this.setState({
			status: {
				form: false,
				btnForm: false,
				btnAksi: false,
				detail: false,
				edit: false,
			},
			dt: formInput,
		})
		this.forceUpdate();
	}

	getFilePreview = (data) => {
			
		const fileParse = data.file;
		// const imageUrl = fileParse.thumbnail;
		const fileUrl = fileParse.url;
		const fileName = fileParse.filename;
		const fileExtension = fileName.split('.').pop().toLowerCase();
	
		switch (fileExtension) {
			case 'png':
			case 'jpg':
			case 'jpeg':
		  	case 'pdf':
			case 'xlsx':
			case 'xls':
			case 'doc':
			case 'docx':
			return <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Download File</a>;
		  
			default:
				return (
				<div>
					<p>Format file ini tidak didukung. Silahkan di Download <a href={fileUrl}>Download</a>.</p>
				</div>
			);
		}
	}

	tombolAksi = (cell, row) => {
		let btnAksi = this.state.akun.sub.data_role.nama !== "Admin";
		return (
			<>
			{btnAksi && (
				<Link to={{ pathname: "/main/detail-invoice-pembelian", state: row }}>
					<Button size="xs" color="primary" className="btn-eye"><i className="fa fa-eye"></i></Button> &nbsp;
				</Link>
			)}
				<Button size="xs" color="success" className="btn-icon mr-1" onClick={() => this.ubahData(row)}><i className="fa fa-pencil"></i></Button> &nbsp;
				<Button size="xs" color="danger" className="btn-icon" onClick={() => this.konfirmHapus(row.uuid)}><i className="fa fa-trash"></i></Button>
			</>
		)
	}

	// ======================= SIMPAN Layanan =====================
	simpanLayanan = e => {
		// e.preventDefault();
		this.setState({
			status:{
				...this.state.status,
				btnForm: true,
			}
		})
		this.forceUpdate();
		let cekLayanan = this.state.data_layanan
		let allLayanan = []
		let dataLayananDesaMobile = ""
		let dataLayananCapilMobile = ""
		let dataLayananKuaMobile = ""
		let dataLayananDesaWeb = ""
		let dataLayananCapilWeb = ""
		let dataLayananKuaWeb = ""
		let dataKoneksiWeb = ""
		let dataLayananPPOB = ""

		let psn = '';
		let resstat = 204;
		let metode = "";

		let ttd_digital = ""
		let tte_digital = ""
		let ketersediaan_info = ""
		let ketersediaan_pengumuman = ""
		let ketersediaan_info_bupati = ""
		let riwayat_disposisi = ""
		let layanan_capil = ""
		let layanan_kua = ""
		let layanan_ppob = ""
		let pembayaran = ""

		if(this.state.ketersedian_ttd === true){
			ttd_digital = 1
		}
		else if(this.state.ketersedian_ttd === false){
			ttd_digital = 0
		}

		if(this.state.status_tte === true){
			tte_digital = 1
		}
		else if(this.state.status_tte === false){
			tte_digital = 0
		}

		if(this.state.ketersediaan_info === true){
			ketersediaan_info = 1
		}
		else if(this.state.ketersediaan_info === false){
			ketersediaan_info = 0
		}

		if(this.state.ketersediaan_pengumuman === true){
			ketersediaan_pengumuman = 1
		}
		else if(this.state.ketersediaan_pengumuman === false){
			ketersediaan_pengumuman = 0
		}

		if(this.state.ketersediaan_info_bupati === true){
			ketersediaan_info_bupati = 1
		}
		else if(this.state.ketersediaan_info_bupati === false){
			ketersediaan_info_bupati = 0
		}

		if(this.state.riwayat_disposisi === true){
			riwayat_disposisi = 1
		}
		else if(this.state.riwayat_disposisi === false){
			riwayat_disposisi = 0
		}

		if(this.state.layanan_capil === true){
			layanan_capil = 1
		}
		else if(this.state.layanan_capil === false){
			layanan_capil = 0
		}

		if(this.state.layanan_kua === true){
			layanan_kua = 1
		}
		else if(this.state.layanan_kua === false){
			layanan_kua = 0
		}

		if(this.state.layanan_ppob === true){
			layanan_ppob = 1
		}
		else if(this.state.layanan_ppob === false){
			layanan_ppob = 0
		}

		if(this.state.pembayaran === true){
			pembayaran = 1
		}
		else if(this.state.pembayaran === false){
			pembayaran = 0
		}

		// let version_desa_app = ""
		// let version_min_desa_app = ""
		// if(this.state.konfig_umum === "inherit"){
		// 	version_desa_app = document.getElementById('version_desa_app').value
		// 	version_min_desa_app = document.getElementById('version_min_desa_app').value
		// }
		// else if(this.state.konfig_umum === "none"){
		// 	version_desa_app = this.state.version_desa_app
		// 	version_min_desa_app = this.state.version_min_desa_app
		// }

		if(this.state.konfig_web === "inherit"){
			dataKoneksiWeb = {
				jenis_desa: document.getElementById('jenis_desa').value,
				jenis_dusun: document.getElementById('jenis_dusun').value,
				kepala_polisi_kecamatan: document.getElementById('kepala_polisi_kecamatan').value,
				kantor_polisi_kecamatan: document.getElementById('kantor_polisi_kecamatan').value,
				kepala_polisi_kabupaten: document.getElementById('kepala_polisi_kabupaten').value,
				kantor_polisi_kabupaten: document.getElementById('kantor_polisi_kabupaten').value,
				kepala_polisi_provinsi: document.getElementById('kepala_polisi_provinsi').value,
				kantor_polisi_provinsi: document.getElementById('kantor_polisi_provinsi').value,
			}
		}
		else if(this.state.konfig_web === "none"){
			dataKoneksiWeb = {
				jenis_desa: this.state.koneksi_web.jenis_desa,
				jenis_dusun: this.state.koneksi_web.jenis_dusun,
				kepala_polisi_kecamatan: this.state.koneksi_web.kepala_polisi_kecamatan,
				kantor_polisi_kecamatan: this.state.koneksi_web.kantor_polisi_kecamatan,
				kepala_polisi_kabupaten: this.state.koneksi_web.kepala_polisi_kabupaten,
				kantor_polisi_kabupaten: this.state.koneksi_web.kantor_polisi_kabupaten,
				kepala_polisi_provinsi: this.state.koneksi_web.kepala_polisi_provinsi,
				kantor_polisi_provinsi: this.state.koneksi_web.kantor_polisi_provinsi,
			}
		}

		this.forceUpdate()

		if(cekLayanan === null){
			// console.log("Data null bos")
			// console.log("Metode Create")
			dataLayananDesaMobile = this.state.list_layanan_desa_mobile
			dataLayananCapilMobile = this.state.list_layanan_capil_mobile
			dataLayananKuaMobile = this.state.list_layanan_kua_mobile
			dataLayananDesaWeb = this.state.list_layanan_desa_web
			dataLayananCapilWeb = this.state.list_layanan_capil_web
			dataLayananKuaWeb = this.state.list_layanan_kua_web
			dataLayananPPOB = this.state.list_layanan_ppob
			allLayanan = {
				uuid_list_api: this.props.location.state.uuid,
				list_layanan_desa_mobile: JSON.stringify(dataLayananDesaMobile),
				list_layanan_capil_mobile: JSON.stringify(dataLayananCapilMobile),
				list_layanan_kua_mobile: JSON.stringify(dataLayananKuaMobile),
				list_layanan_desa_web: JSON.stringify(dataLayananDesaWeb),
				list_layanan_capil_web: JSON.stringify(dataLayananCapilWeb),
				list_layanan_kua_web: JSON.stringify(dataLayananKuaWeb),
				koneksi_web: JSON.stringify(dataKoneksiWeb),
				// version_desa_app: version_desa_app,
				// version_min_desa_app: version_min_desa_app,
				ketersedian_ttd: ttd_digital,
				status_tte: tte_digital,
				ketersediaan_info: ketersediaan_info,
				ketersediaan_pengumuman: ketersediaan_pengumuman,
				ketersediaan_info_bupati: ketersediaan_info_bupati,
				riwayat_disposisi: riwayat_disposisi,
				layanan_capil : layanan_capil,
				layanan_kua : layanan_kua,
				layanan_ppob : layanan_ppob,
				pembayaran : pembayaran,
				list_layanan_ppob : JSON.stringify(dataLayananPPOB),
				status_absensi : this.state.config_list_layanan_desa.status_absensi,
				status_todolist : this.state.config_list_layanan_desa.status_todolist,
			}
			psn = "Tambah";
			resstat = 200;
			metode = "create";
			allLayanan.uuid = null
		}
		else{
			// console.log("Data Ada")
			// console.log("Metode Update")
			dataLayananDesaMobile = this.state.list_layanan_desa_mobile
			dataLayananCapilMobile = this.state.list_layanan_capil_mobile
			dataLayananKuaMobile = this.state.list_layanan_kua_mobile
			dataLayananDesaWeb = this.state.list_layanan_desa_web
			dataLayananCapilWeb = this.state.list_layanan_capil_web
			dataLayananKuaWeb = this.state.list_layanan_kua_web
			dataLayananPPOB = this.state.list_layanan_ppob
			allLayanan = {
				uuid_list_api: this.props.location.state.uuid,
				list_layanan_desa_mobile: JSON.stringify(dataLayananDesaMobile),
				list_layanan_capil_mobile: JSON.stringify(dataLayananCapilMobile),
				list_layanan_kua_mobile: JSON.stringify(dataLayananKuaMobile),
				list_layanan_desa_web: JSON.stringify(dataLayananDesaWeb),
				list_layanan_capil_web: JSON.stringify(dataLayananCapilWeb),
				list_layanan_kua_web: JSON.stringify(dataLayananKuaWeb),
				koneksi_web: JSON.stringify(dataKoneksiWeb),
				// version_desa_app: version_desa_app,
				// version_min_desa_app: version_min_desa_app,
				ketersedian_ttd: ttd_digital,
				status_tte: tte_digital,
				ketersediaan_info: ketersediaan_info,
				ketersediaan_pengumuman: ketersediaan_pengumuman,
				ketersediaan_info_bupati: ketersediaan_info_bupati,
				riwayat_disposisi: riwayat_disposisi,
				layanan_capil : layanan_capil,
				layanan_kua : layanan_kua,
				layanan_ppob : layanan_ppob,
				pembayaran : pembayaran,
				list_layanan_ppob : JSON.stringify(dataLayananPPOB),
				status_absensi : this.state.config_list_layanan_desa.status_absensi,
				status_todolist : this.state.config_list_layanan_desa.status_todolist,
			}
			psn = "Ubah";
			resstat = 200;
			metode = "update";
			allLayanan.uuid = this.state.data_layanan.uuid
		}

		// console.log('Simpan allLayanan')
		// console.log(allLayanan)
		PostMain('main/web/list-layanan-desa/' + metode, allLayanan.uuid, allLayanan, (res) => {
			this.forceUpdate();
			if (res.status === resstat) {
				if(this.state.konfig_umum === "inherit"){
					this.setState({ 
						konfig_umum: "none",
						show: true, 
						basicType: 'success', 
						basicTitle: 'Konfigurasi Layanan', 
						pesanAlert: 'Berhasil ' + psn + ' Data',
					});
				}
				if(this.state.konfig_web === "inherit"){
					this.setState({ 
						konfig_web: "none",
						show: true, 
						basicType: 'success', 
						basicTitle: 'Konfigurasi Layanan', 
						pesanAlert: 'Berhasil ' + psn + ' Data' 
					});
				}
			}
			else {
				this.setState({ show: true, basicType: 'danger', basicTitle: 'Konfigurasi Layanan', pesanAlert: 'Gagal ' + psn + ' Data' });
			}
			this.componentDidMount();
		});
	}
	// ======================= END SIMPAN Layanan =====================

	tombolAksiLayanan = (cell, row) => {
		return (
			<>
				<Button size="xs" color="success" className="btn-icon" onClick={() => this.ubahDataLayanan(row.uuid)} disabled={this.state.status.btnAksi}><i className="fa fa-pencil"></i></Button> &nbsp;&nbsp;
				<Button size="xs" color="danger" className="btn-trash" onClick={() => this.konfirmHapusLayanan(row.uuid)} disabled={this.state.status.btnAksi}><i className="fa fa-trash"></i></Button>
			</>
		)
	}

	componentDidMount() {
		this.fetch({ page: null, where: [] });

		let id_bumdes = this.props.location.state.id_desa;

		// DATA LAYANAN DESA
		GetMain('main/web/list-layanan-desa/' + id_bumdes, null, (data) => {
			if(data.result){
				this.setState({ config_list_layanan_desa: data.result })

				// let layananDesaWebnya = ''
				// let layananKiosK = ''
				// let layananCetakKiosK = ''
				// console.log('layananDesaWebnya')
				// console.log(layananDesaWebnya)
				// console.log(layananKiosK)
				// console.log(layananCetakKiosK)
				
				let layananDesaMobilenya = JSON.parse(data.result.list_layanan_desa_mobile)
				let layananCapilMobilenya = JSON.parse(data.result.list_layanan_capil_mobile)
				let layananKuaMobilenya = JSON.parse(data.result.list_layanan_kua_mobile)
				let layananCapilWebnya = JSON.parse(data.result.list_layanan_capil_web)
				let layananKuaWebnya = JSON.parse(data.result.list_layanan_kua_web)
				let layananPPOB = JSON.parse(data.result.list_layanan_ppob)
				let koneksiWeb = JSON.parse(data.result.koneksi_web)
				let ttd_digital = ""
				let tte_digital = ""
				let ketersediaan_info = ""
				let ketersediaan_pengumuman = ""
				let ketersediaan_info_bupati = ""
				let disposisi = ""
				let layanan_capil = ""
				let layanan_kua = ""
				let layanan_ppob = ""
				let pembayaran = ""

				if(data.result.ketersedian_ttd===1){
					ttd_digital = true
				}
				else if(data.result.ketersedian_ttd===0){
					ttd_digital = false
				}

				if(data.result.status_tte===1){
					tte_digital = true
				}
				else if(data.result.status_tte===0){
					tte_digital = false
				}

				if(data.result.ketersediaan_info===1){
					ketersediaan_info = true
				}
				else if(data.result.ketersediaan_info===0){
					ketersediaan_info = false
				}

				if(data.result.ketersediaan_pengumuman===1){
					ketersediaan_pengumuman = true
				}
				else if(data.result.ketersediaan_pengumuman===0){
					ketersediaan_pengumuman = false
				}

				if(data.result.ketersediaan_info_bupati===1){
					ketersediaan_info_bupati = true
				}
				else if(data.result.ketersediaan_info_bupati===0){
					ketersediaan_info_bupati = false
				}

				if(data.result.riwayat_disposisi===1){
					disposisi = true
				}
				else if(data.result.riwayat_disposisi===0){
					disposisi = false
				}

				if(data.result.layanan_capil===1){
					layanan_capil = true
				}
				else if(data.result.layanan_capil===0){
					layanan_capil = false
				}

				if(data.result.layanan_kua===1){
					layanan_kua = true
				}
				else if(data.result.layanan_kua===0){
					layanan_kua = false
				}

				if(data.result.layanan_ppob===1){
					layanan_ppob = true
				}
				else if(data.result.layanan_ppob===0){
					layanan_ppob = false
				}

				if(data.result.pembayaran===1){
					pembayaran = true
				}
				else if(data.result.pembayaran===0){
					pembayaran = false
				}

				this.setState({
					data_layanan: data.result,
					list_layanan_desa_mobile: layananDesaMobilenya,
					list_layanan_capil_mobile: layananCapilMobilenya,
					list_layanan_kua_mobile: layananKuaMobilenya,
					list_layanan_ppob: layananPPOB,
					list_layanan_capil_web: layananCapilWebnya,
					list_layanan_kua_web: layananKuaWebnya,
					koneksi_web: koneksiWeb,
					version_desa_app: data.result.version_desa_app,
					version_min_desa_app: data.result.version_min_desa_app,
					ketersedian_ttd: ttd_digital,
					status_tte: tte_digital,
					ketersediaan_info: ketersediaan_info,
					ketersediaan_pengumuman: ketersediaan_pengumuman,
					ketersediaan_info_bupati: ketersediaan_info_bupati,
					riwayat_disposisi: disposisi,
					layanan_capil: layanan_capil,
					layanan_kua: layanan_kua,
					layanan_ppob: layanan_ppob,
					pembayaran: pembayaran,
				});
			}
			else{
				this.setState({
					list_layanan_desa_mobile: {
						tidak_mampu: true,
						domisili: true,
						kelahiran: true,
						belum_memiliki_rumah: true,
						jalan: true,
						kematian: true,
						kepemilikan_rumah: true,
						penghasilan: true,
						skck: true,
						kehilangan: true,
						usaha: true,
						skgr: true,
						belum_menikah: true,
						tidak_menikah: true,
						pindah_menikah: true,
						pernah_menikah: true
					},
					list_layanan_capil_mobile: {
						kelahiran: true,
						pindah_datang: true,
						akta_kematian: true,
						penambahan_anak: true,
						pecah_kk: true,
						perubahan_data: true
					},
					list_layanan_kua_mobile: {
						pernikahan: true
					},
					list_layanan_ppob: {
						top_up_bumdes: true,
						transfer_bank: true,
						va: true,
					},
					list_layanan_capil_web: {
						kelahiran: true,
						pindah_datang: true,
						akta_kematian: true,
						penambahan_anak: true,
						pecah_kk: true,
						perubahan_data: true
					},
					list_layanan_kua_web: {
						pernikahan: true
					},
					koneksi_web: {
						jenis_desa: "",
						jenis_dusun: "",
						kepala_polisi_kecamatan: "",
						kantor_polisi_kecamatan: "",
						kepala_polisi_kabupaten: "",
						kantor_polisi_kabupaten: "",
						kepala_polisi_provinsi: "",
						kantor_polisi_provinsi: "",
					},
					version_desa_app: "-",
					version_min_desa_app: "-",
					ketersedian_ttd: false,
					status_tte: false,
					ketersediaan_info: true,
					ketersediaan_pengumuman: true,
					ketersediaan_info_bupati: false,
					riwayat_disposisi: true,
					layanan_capil: false,
					layanan_kua: false,
					layanan_ppob: false,
					pembayaran: false,
				})
			}
		});

		// DATA AKUN BUMDES
		Get('bumdes/desa/' + id_bumdes, null, (data) => {
			if (data.result) {
				// console.log("Data Akun Bumdes")
				// console.log(data.result)
				this.setState({
					data_akun: data.result
				});
			}
		});
		// DATA LISENSI DESA
		Get('invoice-pembelian/list-bydesa/' + id_bumdes, null, (data) => {
			if (data.result) {
				// console.log("Data Lisensi Desa")
				// console.log(data.result)
				this.setState({
					data_lisensi: data.result.data
				});
			}
		});
	}

	// ============================== Ubah Konfig ===============================

	ubahKonfig = (e) => {
		e.preventDefault();
		this.setState({ konfig_umum: 'inherit'});
	};
	// ========================================================================

	// ============================== Ubah Konfig ===============================

	ubahKonfigWeb = (e) => {
		e.preventDefault();
		this.setState({ konfig_web: 'inherit'});
	};
	// ========================================================================

	capitalizeFirstLetter = (string) => {
		return string.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());;
		// return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	render() {

		var data_lisensi = this.state.data_lisensi;

		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: (key, obj, index) =>{          
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index+1);
					let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
					return serial_num; 
				}
			},
			{
				dataField: 'no_invoice',
				text: 'No. Invoice',
				headerAlign: 'center',
				sort: true
			},
			{
				dataField: 'lisensi',
				text: 'Lisensi',
				headerAlign: 'center',
				sort: true
			},
			{
				dataField: 'tgl_pembelian',
				text: 'Tanggal Pembelian',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},
			{
				dataField: 'tgl_expired',
				text: 'Tanggal Expired',
				headerAlign: 'center',
				align: 'center',
				sort: true
			},	
			{
				dataField: 'total_biaya',
				text: 'Total Biaya',
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: this.currencyFormatter,
			},	
			{
				dataField: 'sisa_bayar',
				text: 'Sisa Bayar',
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: this.currencyFormatter,
			},
			{
				dataField: "sisa_bayar",
				text: "Status Pembayaran",
				headerAlign: 'center',
				align: 'center',
				sort: true,
				formatter: (cell, obj) => {
					if (obj.sisa_bayar !== undefined) {
						let sisa_bayar = obj.sisa_bayar;
						let status_pembayaran = '';
						let colorStyle = {};
						
						if (sisa_bayar === 0) {
							colorStyle = { color: 'green' };
							status_pembayaran = "Lunas";
						} else {
							colorStyle = { color: 'red' };
							status_pembayaran = "Belum Lunas";
						}

						return (
							<span style={colorStyle}>
								{status_pembayaran}
							</span>
						);
					}
					return <span style={{ color: 'gray' }}>Data Tidak Tersedia</span>;
				},
			},
			{
				dataField: 'aksi',
				text: 'Aksi',
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: this.tombolAksi,
			},
		];

		return (
			<div>
				<Breadcrumb title="Detail Konfigurasi Desa" parent="Admin" />
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-body datatable-react">
									{this.state.akun.sub.data_role.nama !== "Admin" ? (
										<>
											<div className="row">
												<div className="col-sm-6">
													<input
														type="search"
														className="form-control"
														id="cariTable"
														placeholder="Cari Disini..."
														defaultValue={this.state.dataCari.q}
														onKeyPress={this.cariData}
													/>
												</div>
												<div className="col-sm-6 text-right">
													<Button
														size="sm"
														color="default"
														style={{ backgroundColor: '#FFC312' }}
														onClick={this.props.history.goBack}
														className="mr-2"
													>
														<i className="fa fa-arrow-left"></i> Kembali
													</Button>
													<Button 
														size="sm" 
														color="success" 
														className="btn-square" 
														onClick={() => {
															this.setState({ 
																judul: "Tambah Invoice Pembelian", 
																dt: formInput 
															}); 
															this.bukaForm('tambah'); 
														}}>
															Tambah Data
													</Button>
												</div>
											</div>

											<BootstrapTable
												keyField="uuid"
												data={data_lisensi}
												columns={columns}
											/>
											<div className="pull-right text-white">
												{this.state.awal}
												{this.state.sebelum}
												{this.state.hal.map((dt) => {
													return dt;
												})}
												{this.state.setelah}
												{this.state.akhir}
											</div>
										</>
									):(
										<>
											<div className="row">
												<div className="col-sm-4">
													&nbsp;
												</div>
												<div className="col-sm-8 text-right">
													<Button onClick={this.props.history.goBack} color="default" style={{ backgroundColor: '#FFC312' }}><i className="fa fa-arrow-left"></i> Kembali</Button>
												</div>
											</div>

											<br/><br/>
											<div>
												<Nav tabs className="tabs-color">
													<NavItem>
														<NavLink className={classnames({ active: this.state.active_tab_icon === '1' })}
															onClick={() => { this.toggle_icon('1'); }} >
															<i className="icofont icofont-user"></i>Akun Bumdes
														</NavLink>
													</NavItem>
													<NavItem>
														<NavLink className={classnames({ active: this.state.active_tab_icon === '2' })}
															onClick={() => { this.toggle_icon('2'); }} >
															<i className="icofont icofont-key"></i>Pendaftaran Lisensi
														</NavLink>
													</NavItem>
													<NavItem>
														<NavLink className={classnames({ active: this.state.active_tab_icon === '3' })}
															onClick={() => { this.toggle_icon('3'); }} >
															<i className="icofont icofont-gears"></i>Layanan Desa
														</NavLink>
													</NavItem>
												</Nav>
												{/* ===============================================================										 */}
												<TabContent activeTab={this.state.active_tab_icon}>
													<TabPane tabId="1">
														<div style={{ marginTop: 15 }}>
															<Row>
																<Col sm="12">
																	<br />

																	<div><br /><br /><h2 align="center">Akun Bumdes</h2><hr /><br /><br /></div>

																	<Form className="theme-form" onSubmit={this.simpan_akun}>
																		<div className="modal-body">
																			<input className="form-control" id="uuid" type="hidden" placeholder="UUID" defaultValue={this.state.akun.uuid} />
																			<input className="form-control" id="id_desa" type="hidden" placeholder="id Desa" defaultValue={this.props.location.state.id_desa} />
																			<input className="form-control" id="role" type="hidden" placeholder="Role" defaultValue='2' />

																			<FormGroup className="row">
																				<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Nama Desa</Label>
																				<Col sm='9'>
																					<input className="form-control" id="nama_desa" type="text" placeholder="Nama Desa" defaultValue={this.props.location.state.data_desa.nama} disabled />
																				</Col>
																			</FormGroup>


																			<FormGroup className="row">
																				<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Username Bumdes</Label>
																				<Col sm='9'>
																					<input className="form-control" id="username" type="text" placeholder="Username Bumdes" defaultValue={this.state.akun.username} required />
																				</Col>
																			</FormGroup>

																			<FormGroup className="row">
																				<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Password Bumdes</Label>
																				<Col sm='9'>
																					<input className="form-control" id="password" type="password" placeholder="Password Bumdes" required />
																				</Col>
																			</FormGroup>
																			<FormGroup className="row">
																				<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">No. Handphone</Label>
																				<Col sm='9'>
																					<input className="form-control" id="no_hp" type="text" placeholder="No. Handphone Pengguna" defaultValue={this.state.akun.no_hp} required />
																				</Col>
																			</FormGroup>
																			<FormGroup className="row">
																				<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Email</Label>
																				<Col sm='9'>
																					<input className="form-control" id="email" type="text" placeholder="Email Pengguna" defaultValue={this.state.akun.email} />
																				</Col>
																			</FormGroup>
																		</div>
																		<div className="modal-footer">
																			<button type="submit" className="btn btn-success" disabled={this.state.status.btnForm} onClick={this.simpan_akun}>Simpan</button>
																		</div>
																	</Form>
																</Col>
															</Row>

														</div>
													</TabPane>
													{/* =========================================================================== */}
													<TabPane tabId="2">
														<div style={{ marginTop: 15 }}>
															<Row>
																<Col sm="12">
																	<br />
																	<h2 align="center">Pendaftaran Lisensi</h2>
																	<br/><br/>
																	<div className="col-md-12 text-right">
																		<Button 
																		size="md" 
																		color="success" 
																		className="btn-icon" 
																		onClick={() => 
																			this.tambahDataLisensi('create','')} 
																		disabled={this.state.status.btnAksi}>Tambah Data Lisensi</Button> 
																	</div>
																	<div>
																		<br/>&nbsp;<br/>
																	</div>
																	{ this.state.data_lisensi ?
																		<>
																			<div className="col-md-12 text-center">
																			<BootstrapTable
																				keyField="uuid"
																				data={data_lisensi}
																				columns={columns}
																			/>
																			</div>
																		</>
																	: (
																		<div className="col-md-12 text-center">
																			<h4 align="center">Data Tidak Dapat Ditemukan</h4>
																		</div>
																	)}
																</Col>
															</Row>

														</div>
													</TabPane>
													{/* =========================================================================== */}
													<TabPane tabId="3">
														<div style={{ marginTop: 15 }}>
															<Row>
																<Col sm="12">
																	<div className="card-body">
																		<div className="row">
																			<div className="col-sm-3 col-xs-12">
																				<Nav  className={'nav flex-column nav-pills'}>
																					<NavItem>
																						<NavLink className={classnames({ active: this.state.active_tab_vertical === '1' })}
																								onClick={() => { this.toggle_vertical('1'); }}>
																							Umum
																						</NavLink>
																					</NavItem>
																					<NavItem>
																						<NavLink className={classnames({ active: this.state.active_tab_vertical === '6' })}
																								onClick={() => { this.toggle_vertical('6'); }} >
																							Disdukcapil Mobile
																						</NavLink>
																					</NavItem>
																					<NavItem>
																						<NavLink className={classnames({ active: this.state.active_tab_vertical === '7' })}
																								onClick={() => { this.toggle_vertical('7'); }}>
																							KUA Mobile
																						</NavLink>
																					</NavItem>
																					<NavItem>
																						<NavLink className={classnames({ active: this.state.active_tab_vertical === '9' })}
																								onClick={() => { this.toggle_vertical('9'); }} >
																							Disdukcapil Web
																						</NavLink>
																					</NavItem>
																					<NavItem>
																						<NavLink className={classnames({ active: this.state.active_tab_vertical === '10' })}
																								onClick={() => { this.toggle_vertical('10'); }}>
																							KUA Web
																						</NavLink>
																					</NavItem>
																					<NavItem>
																						<NavLink className={classnames({ active: this.state.active_tab_vertical === '12' })}
																								onClick={() => { this.toggle_vertical('12'); }}>
																							Layanan PPOB
																						</NavLink>
																					</NavItem>
																				</Nav>
																			</div>
																			<div className="col-sm-9 col-xs-12">
																				<TabContent activeTab={this.state.active_tab_vertical}>
																					<TabPane tabId="1">
																						<Row>
																							<Col sm="12">
																								<p>
																									<div>
																										{ 
																											this.state.konfig_umum === 'none'
																											?
																											<div className="row">
																												<div className="col-md-12 text-right">
																														<Button  size="md" color="primary" className="btn-icon" onClick={this.ubahKonfig}><i className="fa fa-pencil"></i> Ubah Konfigurasi</Button> 
																												</div>
																												
																												<br/>
																												<div className="col-sm-12" align="center">
																													<b>Konfigurasi Umum</b>
																												</div>
																												<br/>

																												{/* <div className="col-sm-6">
																													<Label className="col-form-label" htmlFor="inputEmail3">
																														Version Desa App
																													</Label>
																													<input
																														className="form-control"
																														id="version_desa_app"
																														type="text"
																														placeholder="Version Desa App"
																														defaultValue={this.state.version_desa_app}
																														readOnly
																													/>
																												</div>
																												<div className="col-sm-6">
																													<Label className="col-form-label" htmlFor="inputEmail3">
																														Version Desa Min Desa App
																													</Label>
																													<input
																														className="form-control"
																														id="version_min_desa_app"
																														type="text"
																														placeholder="Version Min Desa App"
																														defaultValue={this.state.version_min_desa_app}
																														readOnly
																													/>
																												</div> */}
																												<br/>
																												<div className="col-sm-9" align="left">
																													Tanda Tangan Digital
																												</div>
																												<div className="col-sm-3" align="right">
																													{/* <Switch 
																														onChange={(e) => {
																														this.handleChange();
																														}}
																														checked='true' 
																													/> */}
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'ketersediaan_ttd');
																														}}
																														checked={this.state.ketersedian_ttd} 
																														disabled
																													/>
																												</div>

																												<div className="col-sm-9" align="left">
																													Tanda Tangan Elektronik Kominfo
																												</div>
																												<div className="col-sm-3" align="right">
																													{/* <Switch 
																														onChange={(e) => {
																														this.handleChange();
																														}}
																														checked='true' 
																													/> */}
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'status_tte');
																														}}
																														checked={this.state.status_tte} 
																														disabled
																													/>
																												</div>
																												
																												<div className="col-sm-9" align="left">
																													Riwayat Disposisi
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'riwayat_disposisi');
																														}}
																														checked={this.state.riwayat_disposisi} 
																														disabled
																													/>
																												</div>

																												<div className="col-sm-9" align="left">
																													Aplikasi Berbayar
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'pembayaran');
																														}}
																														checked={this.state.pembayaran} 
																														disabled
																													/>
																												</div>	
																												
																												<div className="col-sm-9" align="left">
																													Aplikasi Absensi
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeConfigLayananDesa(e,'status_absensi');
																														}}
																														checked={this.state.config_list_layanan_desa ? this.state.config_list_layanan_desa.status_absensi : false} 
																														disabled
																													/>
																												</div>	
																												
																												<div className="col-sm-9" align="left">
																													Aplikasi To Do List
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeConfigLayananDesa(e,'status_todolist');
																														}}
																														checked={this.state.config_list_layanan_desa ? this.state.config_list_layanan_desa.status_todolist : false} 
																														disabled
																													/>
																												</div>	

																												<br/>
																												<div className="col-sm-12" align="center">
																													<b>Konfigurasi Layanan</b>
																												</div>
																												<br/>
																												
																												<div className="col-sm-9" align="left">
																													Layanan Capil
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'layanan_capil');
																														}}
																														checked={this.state.layanan_capil} 
																														disabled
																													/>
																												</div>
																												
																												<div className="col-sm-9" align="left">
																													Layanan KUA
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'layanan_kua');
																														}}
																														checked={this.state.layanan_kua} 
																														disabled
																													/>
																												</div>
																												
																												<div className="col-sm-9" align="left">
																													Layanan PPOB
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'layanan_ppob');
																														}}
																														checked={this.state.layanan_ppob} 
																														disabled
																													/>
																												</div>

																												<br/>
																												<div className="col-sm-12" align="center">
																													<b>Info dan Pengumuman</b>
																												</div>
																												<br/>

																												<div className="col-sm-9" align="left">
																													Ketersediaan Info
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'ketersediaan_info');
																														}}
																														checked={this.state.ketersediaan_info} 
																														disabled
																													/>
																												</div>

																												<div className="col-sm-9" align="left">
																													Ketersediaan Info Bupati
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'ketersediaan_info_bupati');
																														}}
																														checked={this.state.ketersediaan_info_bupati} 
																														disabled
																													/>
																												</div>

																												<div className="col-sm-9" align="left">
																													Ketersediaan Pengumuman
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'ketersediaan_pengumuman');
																														}}
																														checked={this.state.ketersediaan_pengumuman} 
																														disabled
																													/>
																												</div>
																												
																											</div>
																											:
																											<div className="row">
																												<div className="col-md-12 text-right">
																														<Button  size="md" color="success" className="btn-icon" onClick={() => this.simpanLayanan()}><i className="fa fa-save"></i> Simpan</Button> 
																												</div>
																												
																												<br/>
																												<div className="col-sm-12" align="center">
																													<b>Konfigurasi Umum</b>
																												</div>
																												<br/>

																												{/* <div className="col-sm-6">
																													<Label className="col-form-label" htmlFor="inputEmail3">
																														Version Desa App
																													</Label>
																													<input
																														className="form-control"
																														id="version_desa_app"
																														type="text"
																														placeholder="Version Desa App"
																														defaultValue={this.state.version_desa_app}
																														required
																													/>
																												</div>
																												<div className="col-sm-6">
																													<Label className="col-form-label" htmlFor="inputEmail3">
																														Version Desa Min Desa App
																													</Label>
																													<input
																														className="form-control"
																														id="version_min_desa_app"
																														type="text"
																														placeholder="Version Min Desa App"
																														defaultValue={this.state.version_min_desa_app}
																														required
																													/>
																												</div> */}
																												<br/>
																												<div className="col-sm-9" align="left">
																													Tanda Tangan Digital
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'ketersediaan_ttd');
																														}}
																														checked={this.state.ketersedian_ttd} 
																													/>
																												</div>

																												<div className="col-sm-9" align="left">
																													Tanda Tangan Elektronik Kominfo
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'status_tte');
																														}}
																														checked={this.state.status_tte} 
																													/>
																												</div>
																												
																												<div className="col-sm-9" align="left">
																													Riwayat Disposisi
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'riwayat_disposisi');
																														}}
																														checked={this.state.riwayat_disposisi} 
																													/>
																												</div>
																												
																												<div className="col-sm-9" align="left">
																													Aplikasi Berbayar
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'pembayaran');
																														}}
																														checked={this.state.pembayaran} 
																													/>
																												</div>

																												<div className="col-sm-9" align="left">
																													Aplikasi Absensi
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeConfigLayananDesa(e,'status_absensi');
																														}}
																														checked={this.state.config_list_layanan_desa ? this.state.config_list_layanan_desa.status_absensi : false}
																													/>
																												</div>

																												<div className="col-sm-9" align="left">
																													Aplikasi To Do List
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeConfigLayananDesa(e,'status_todolist');
																														}}
																														checked={this.state.config_list_layanan_desa ? this.state.config_list_layanan_desa.status_todolist : false}
																													/>
																												</div>

																												<br/>
																												<div className="col-sm-12" align="center">
																													<b>Konfigurasi Layanan</b>
																												</div>
																												<br/>

																												<div className="col-sm-9" align="left">
																													Layanan Capil
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'layanan_capil');
																														}}
																														checked={this.state.layanan_capil} 
																													/>
																												</div>
																												
																												<div className="col-sm-9" align="left">
																													Layanan KUA
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'layanan_kua');
																														}}
																														checked={this.state.layanan_kua} 
																													/>
																												</div>
																												
																												<div className="col-sm-9" align="left">
																													Layanan PPOB
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'layanan_ppob');
																														}}
																														checked={this.state.layanan_ppob} 
																													/>
																												</div>

																												<br/>
																												<div className="col-sm-12" align="center">
																													<b>Info dan Pengumuman</b>
																												</div>
																												<br/>

																												<div className="col-sm-9" align="left">
																													Ketersediaan Info
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'ketersediaan_info');
																														}}
																														checked={this.state.ketersediaan_info} 
																													/>
																												</div>

																												<div className="col-sm-9" align="left">
																													Ketersediaan Info Bupati
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'ketersediaan_info_bupati');
																														}}
																														checked={this.state.ketersediaan_info_bupati} 
																													/>
																												</div>

																												<div className="col-sm-9" align="left">
																													Ketersediaan Pengumuman
																												</div>
																												<div className="col-sm-3" align="right">
																													<Switch 
																														onChange={(e) => {
																														this.handleChangeUmum(e,'ketersediaan_pengumuman');
																														}}
																														checked={this.state.ketersediaan_pengumuman} 
																													/>
																												</div>
																												
																											</div>
																										}
																									
																									</div>
																								</p>
																							</Col>
																						</Row>
																					</TabPane>
																					<TabPane tabId="6">
																						<Row>
																							<Col sm="12">
																								<p>
																								<div className="card-body datatable-react">
																										<div>
																										{Object.keys(this.state.list_layanan_capil_mobile).map((val, index) => {
																												let jenis_layanan_capil_mobile = 'Jenis Layanan Desa Mobile'
																												let value_jenis_layanan_capil_mobile = ''
																												switch (val) {
																													case 'kelahiran':
																														jenis_layanan_capil_mobile = "Kelahiran"
																														value_jenis_layanan_capil_mobile = this.state.list_layanan_capil_mobile.kelahiran
																														break;
																													case 'pindah_datang':
																														jenis_layanan_capil_mobile = "Pindah Datang"
																														value_jenis_layanan_capil_mobile = this.state.list_layanan_capil_mobile.pindah_datang
																														break;
																													case 'akta_kematian':
																														jenis_layanan_capil_mobile = "Akta Kematian"
																														value_jenis_layanan_capil_mobile = this.state.list_layanan_capil_mobile.akta_kematian
																														break;
																													case 'penambahan_anak':
																														jenis_layanan_capil_mobile = "Penambahan Anak"
																														value_jenis_layanan_capil_mobile = this.state.list_layanan_capil_mobile.penambahan_anak
																														break;
																													case 'pecah_kk':
																														jenis_layanan_capil_mobile = "Pecah Kartu Keluarga"
																														value_jenis_layanan_capil_mobile = this.state.list_layanan_capil_mobile.pecah_kk
																														break;
																													case 'perubahan_data':
																														jenis_layanan_capil_mobile = "Perubahan Data"
																														value_jenis_layanan_capil_mobile = this.state.list_layanan_capil_mobile.perubahan_data
																														break;
																													default:
																														// Tetap menggunakan nilai awal jika tidak ada case yang cocok
																														this.setState({
																															show: true,
																															basicType: "danger",
																															basicTitle: "Gagal Ubah Status",
																															pesanAlert: `Unrecognized value: ${val}`
																														})
																														console.warn(`Unrecognized value: ${val}`);
																														break;
																												}

																												return (
																													
																												<div className="row">
																													<div className="col-sm-6" align="center">
																														{jenis_layanan_capil_mobile}
																													</div>
																													<div className="col-sm-4" align="center">
																														<Switch 
																															onChange={(e) => {
																															this.handleChange(e, val+'_capil_mobile');
																															}}
																															checked={value_jenis_layanan_capil_mobile} 
																														/>
																													</div>
																												</div>
																												)
																											})
																										}
																										</div>
																									</div>
																								</p>
																							</Col>
																						</Row>
																					</TabPane>
																					<TabPane tabId="7">
																						<Row>
																							<Col sm="12">
																								<p>
																									<div className="card-body datatable-react">
																										<div>
																										{
																											Object.keys(this.state.list_layanan_kua_mobile).map((val, index) => {
																												let jenis_layanan_kua_mobile = 'Jenis Layanan KUA Mobile'
																												let value_jenis_layanan_kua_mobile = ''
																												switch (val) {
																													case 'pernikahan':
																														jenis_layanan_kua_mobile = "pernikahan"
																														value_jenis_layanan_kua_mobile = this.state.list_layanan_kua_mobile.pernikahan
																														break;
																													default:
																														// Tetap menggunakan nilai awal jika tidak ada case yang cocok
																														this.setState({
																															show: true,
																															basicType: "danger",
																															basicTitle: "Gagal Ubah Status",
																															pesanAlert: `Unrecognized value: ${val}`
																														})
																														console.warn(`Unrecognized value: ${val}`);
																														break;
																												}

																												return (
																													
																												<div className="row">
																													<div className="col-sm-6" align="center">
																														{jenis_layanan_kua_mobile}
																													</div>
																													<div className="col-sm-4" align="center">
																														<Switch 
																															onChange={(e) => {
																															this.handleChange(e, val);
																															}}
																															checked={value_jenis_layanan_kua_mobile} 
																														/>
																													</div>
																												</div>
																												)
																											})
																										}
																										</div>
																									</div>
																								</p>
																							</Col>
																						</Row>
																					</TabPane>
																					<TabPane tabId="9">
																						<Row>
																							<Col sm="12">
																								<p>
																								<div className="card-body datatable-react">
																										<div>
																										{
																											Object.keys(this.state.list_layanan_capil_web).map((val, index) => {
																												let jenis_layanan_capil_web = 'Jenis Layanan Capil Web'
																												let value_jenis_layanan_capil_web = ''
																												switch (val) {
																													case 'kelahiran':
																														jenis_layanan_capil_web = "Kelahiran"
																														value_jenis_layanan_capil_web = this.state.list_layanan_capil_web.kelahiran
																														break;
																													case 'pindah_datang':
																														jenis_layanan_capil_web = "Pindah Datang"
																														value_jenis_layanan_capil_web = this.state.list_layanan_capil_web.pindah_datang
																														break;
																													case 'akta_kematian':
																														jenis_layanan_capil_web = "Akta Kematian"
																														value_jenis_layanan_capil_web = this.state.list_layanan_capil_web.akta_kematian
																														break;
																													case 'penambahan_anak':
																														jenis_layanan_capil_web = "Penambahan Anak"
																														value_jenis_layanan_capil_web = this.state.list_layanan_capil_web.penambahan_anak
																														break;
																													case 'pecah_kk':
																														jenis_layanan_capil_web = "Pecah Kartu Keluarga"
																														value_jenis_layanan_capil_web = this.state.list_layanan_capil_web.pecah_kk
																														break;
																													case 'perubahan_data':
																														jenis_layanan_capil_web = "Perubahan Data"
																														value_jenis_layanan_capil_web = this.state.list_layanan_capil_web.perubahan_data
																														break;
																													default:
																														// Tetap menggunakan nilai awal jika tidak ada case yang cocok
																														this.setState({
																															show: true,
																															basicType: "danger",
																															basicTitle: "Gagal Ubah Status",
																															pesanAlert: `Unrecognized value: ${val}`
																														})
																														console.warn(`Unrecognized value: ${val}`);
																														break;
																												}

																												return (
																													
																												<div className="row">
																													<div className="col-sm-6" align="center">
																														{jenis_layanan_capil_web}
																													</div>
																													<div className="col-sm-4" align="center">
																														<Switch 
																															onChange={(e) => {
																															this.handleChange(e, val+'_capil_web');
																															}}
																															checked={value_jenis_layanan_capil_web} 
																														/>
																													</div>
																												</div>
																												)
																											})
																										}
																										</div>
																									</div>
																								</p>
																							</Col>
																						</Row>
																					</TabPane>
																					<TabPane tabId="10">
																						<Row>
																							<Col sm="12">
																								<p>
																									<div className="card-body datatable-react">
																										<div>
																										{
																											Object.keys(this.state.list_layanan_kua_web).map((val, index) => {
																												let jenis_layanan_kua_web = 'Jenis Layanan KUA Web'
																												let value_jenis_layanan_kua_web = ''
																												switch (val) {
																													case 'pernikahan':
																														jenis_layanan_kua_web = "pernikahan"
																														value_jenis_layanan_kua_web = this.state.list_layanan_kua_web.pernikahan
																														break;
																													default:
																														// Tetap menggunakan nilai awal jika tidak ada case yang cocok
																														this.setState({
																															show: true,
																															basicType: "danger",
																															basicTitle: "Gagal Ubah Status",
																															pesanAlert: `Unrecognized value: ${val}`
																														})
																														console.warn(`Unrecognized value: ${val}`);
																														break;
																												}

																												return (
																													
																												<div className="row">
																													<div className="col-sm-6" align="center">
																														{jenis_layanan_kua_web}
																													</div>
																													<div className="col-sm-4" align="center">
																														<Switch 
																															onChange={(e) => {
																															this.handleChange(e, val+'_kua_web');
																															}}
																															checked={value_jenis_layanan_kua_web} 
																														/>
																													</div>
																												</div>
																												)
																											})
																										}
																										</div>
																									</div>
																								</p>
																							</Col>
																						</Row>
																					</TabPane>
																					<TabPane tabId="12">
																						<Row>
																							<Col sm="12">
																								<p>
																									<div className="card-body datatable-react">
																										<div>
																										{
																											Object.keys(this.state.list_layanan_ppob).map((val, index) => {
																												let jenis_layanan_ppob = 'Jenis Layanan PPOB'
																												let value_jenis_layanan_ppob = ''
																												switch (val) {
																													case 'top_up_bumdes':
																														jenis_layanan_ppob = "Top Up BUMDes"
																														value_jenis_layanan_ppob = this.state.list_layanan_ppob.top_up_bumdes
																														break;
																													case 'transfer_bank':
																														jenis_layanan_ppob = "Transfer Bank"
																														value_jenis_layanan_ppob = this.state.list_layanan_ppob.transfer_bank
																														break;
																													case 'va':
																														jenis_layanan_ppob = "Virtual Account"
																														value_jenis_layanan_ppob = this.state.list_layanan_ppob.va
																														break;
																													default:
																														// Opsi default (tetap menggunakan nilai awal)
																														this.setState({
																															show: true,
																															basicType: "danger",
																															basicTitle: "Gagal Ubah Status",
																															pesanAlert: `Unrecognized value: ${val}`
																														})
																														console.warn(`Unrecognized value: ${val}`);
																														break;
																												}

																												return (
																													
																												<div className="row">
																													<div className="col-sm-6" align="center">
																														{jenis_layanan_ppob}
																													</div>
																													<div className="col-sm-4" align="center">
																														<Switch 
																															onChange={(e) => {
																															this.handleChange(e, val);
																															}}
																															checked={value_jenis_layanan_ppob} 
																														/>
																													</div>
																												</div>
																												)
																											})
																										}
																										</div>
																									</div>
																								</p>
																							</Col>
																						</Row>
																					</TabPane>
																				</TabContent>
																			</div>
																		</div>
																	</div>
																</Col>
															</Row>

														</div>
													</TabPane>
												</TabContent>

											</div>
										</>
									)}
									
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				{/* Loading preview */}
				<SweetAlert
					show={this.state.loadingPreview}
					showCancel = {false}
					showConfirm={false}
				>
					<div align="center">
						<h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
						<br/>
						<img 
							alt="loading"
							src={require("../../assets/images/tes-loading.gif")} 
							style={{
								// width: "100%",
								borderRadius: "10px",
								width: '150px'
							}}
						/> 
						<br/><br/>
					</div>
				</SweetAlert>
				
				<Modal styles={{ modal: { width: "70%" } }} open={this.state.status.form} onClose={this.tutupForm} closeOnEsc={false} closeOnOverlayClick={false}>
					<Form className="theme-form" onSubmit={this.simpan}>
						<div className="modal-header">
							<h5 className="modal-title">{this.state.judul}</h5>
						</div>
						<div className="modal-body">
							<input className="form-control" id="uuid" type="hidden" placeholder="Uuid" defaultValue={this.state.dt.uuid} />
							<FormGroup className="row">
									<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Tanggal Pembelian</Label>
									<Col sm='9'>
										<input className="form-control" 
										id="tgl_pembelian" 
										type="date" 
										placeholder="Tanggal Pembelian" 
										defaultValue={this.state.dt.tgl_pembelian} 
										required/>
									</Col>
							</FormGroup>
							<FormGroup className="row">
									<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Tanggal Expired</Label>
									<Col sm='9'>
										<input className="form-control" 
										id="tgl_expired" 
										type="date" 
										placeholder="Tanggal Expired" 
										defaultValue={this.state.dt.tgl_expired} 
										required/>
									</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Total Biaya</Label>
								<Col sm='9'>
								<input
									data-testid="total_biaya"
									id="total_biaya"
									name="total_biaya"
									className="form-control"
									value={this.formatCurrency(this.state.dt.total_biaya)}
									onChange={(e) => this.handleInputChange(e, 'total_biaya')}
									required
								/>
								</Col>
							</FormGroup>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-warning" onClick={this.tutupForm}>Tutup</button>
							<button type="submit" className="btn btn-success" onClick={this.simpan}>Simpan</button>
						</div>
					</Form>
				</Modal>
			</div>
		)
	}
}


export default InvoicePembelian;
